export type CustomSuburb = {
	id: string;
	placeId: string | null;
	boundaryFeature: GeoJSON.Feature;
};

// Create a type guard function to check if the boundaryFeature is defined
export const hasCustomSuburb = <S extends CustomSuburb>(s: Partial<S>): s is S =>
	s.boundaryFeature !== null;
